import React, { useEffect } from 'react';

import { createStore } from 'state-pool';
import { switchAppStore } from './core/state';

export let contextStore = null;
export const APP_CONTEXT = 'appContext';

export const createAppContext = (instanceId) => {
  if (contextStore === null) {
    contextStore = createStore();        
    contextStore.setState(APP_CONTEXT, { instanceId: instanceId, initialized : false });
  }
}

export function getAppInstance() : any {
  if (contextStore === null) {
    throw new Error("contextStore is not initialized");
  }
  const context = contextStore.getState(APP_CONTEXT);
  return context.getValue().instanceId;
}

export function instanceInitializationBlocked(newInstance) : boolean {
  if (contextStore === null) {
    throw new Error("contextStore is not initialized");
  }
  const context = contextStore.getState(APP_CONTEXT);

  if (!context.getValue().initialized && newInstance !== context.getValue().instanceId) {    
    return true
  }
  return false; 
}

export function setAppInstanceInitialized(instanceId: string) : void {
  if (contextStore === null) {
    throw new Error("contextStore is not initialized");
  }
  const context = contextStore.getState(APP_CONTEXT);
  context.updateValue((data) => {
    return { instanceId : instanceId, initialized: true }
  } );
  switchAppStore(instanceId);
}


export function setAppInstance(instanceId : string) : void {
  if (contextStore === null) {
    throw new Error("contextStore is not initialized");
  }
  const context = contextStore.getState(APP_CONTEXT);
  const initializing = !context.getValue().initialized;
  
  if (initializing && instanceId !== context.getValue().instanceId) {
    return;
  }  
  
  context.updateValue((data) => {
    return { instanceId: instanceId, initialized:context.getValue().initialized }
  } );
  switchAppStore(instanceId);
}

export const AppContext = ({instanceId, children}) => {
  createAppContext(instanceId);
  return (
    <>
      {children}
    </>
  )
}